import { InputHTMLAttributes, forwardRef } from 'react';
import { cn } from '../../lib/utils/classnameVariants';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  error?: boolean;
  validated?: boolean;
}

const Input = forwardRef<HTMLInputElement, InputProps>(({ className, type, error, validated, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(
        'text-base flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:bg-white disabled:opacity-50 md:text-sm',
        error || validated ? 'pr-10' : '',
        className,
      )}
      ref={ref}
      {...props}
    />
  );
});
Input.displayName = 'Input';

export { Input };
